import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { FAQ_ITEMS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="eyebrow text-water-deep/80">Asiakkaat</p>
          <h2 className="h-section font-heading mt-5 font-semibold text-foreground" lang="fi">
            Mitä asiakkaamme sanovat
          </h2>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-[2rem] bg-white p-8 md:p-10 shadow-[0_10px_40px_-18px_rgba(23,68,94,0.18)]"
            >
              <Quote size={26} className="text-water" strokeWidth={1.6} />
              <blockquote className="mt-6 font-heading text-xl italic text-foreground/50">
                [Asiakaspalaute tulossa]
              </blockquote>
              <figcaption className="mt-6 text-xs font-bold uppercase tracking-widest text-muted-foreground">
                Aito asiakaspalaute lisätään tähän pian
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FaqShort() {
  return (
    <section data-testid="faq-short-section" className="py-24 md:py-36 bg-white">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <p className="eyebrow text-water-deep/80">Usein kysytyt kysymykset</p>
        <h2 className="h-section font-heading mt-5 font-semibold text-foreground" lang="fi">
          Hyvä tietää ennen tilausta
        </h2>
        <div className="mt-12">
          <Accordion type="single" collapsible>
            {FAQ_ITEMS.slice(0, 5).map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-short-item-${i}`}>
                <AccordionTrigger className="text-left font-heading text-lg font-semibold">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <Link
          to="/ukk/"
          data-testid="faq-short-link"
          className="mt-10 inline-flex items-center gap-2 text-sm font-bold text-primary transition-colors hover:text-water-deep"
        >
          Katso kaikki kysymykset <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}

export function FinalCta() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden water-gradient grain py-28 md:py-44"
    >
      <div className="mx-auto max-w-5xl px-5 sm:px-8 text-center">
        <h2 className="h-display font-heading font-semibold text-foreground" lang="fi">
          Pieni muutos suihkussa. <span className="italic text-water-deep">Iso ero</span> iholle ja
          hiuksille.
        </h2>
        <p className="mx-auto mt-7 max-w-xl text-base md:text-lg leading-relaxed text-muted-foreground">
          JINSU – puhtaampaa vettä ihollesi ja hiuksillesi. Toimitus Postilla kaikkialle Suomeen.
        </p>
        <Link
          to="/kauppa/"
          data-testid="final-cta-button"
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-primary px-9 py-4 text-base font-bold text-primary-foreground shadow-xl shadow-primary/25 transition-transform duration-200 hover:scale-[1.05]"
        >
          Siirry kauppaan <ArrowRight size={18} />
        </Link>
      </div>
    </section>
  );
}
